const ProcessingStatusEnum = {
    NOT_PROCESSED: 0,
    SUCESSFULLY_PROCESSED: 1,
    PROCESSED_WITH_ERROR: 2,
};

const ProcessingStatusLabel = new Map([
    [ProcessingStatusEnum.NOT_PROCESSED, 'Pendente'],
    [ProcessingStatusEnum.SUCESSFULLY_PROCESSED, 'Completo'],
    [ProcessingStatusEnum.PROCESSED_WITH_ERROR, 'Erro'],
]);

export { ProcessingStatusEnum, ProcessingStatusLabel };
